<template>
    <v-app>
        <div class="video-background">
            <video autoplay muted loop playsinline class="video-element">
                <source src="../../assets/videos/video_traycco.mp4" type="video/mp4">
                Tu navegador no acepta video
            </video>

            <v-container fluid fill-height class="content-overlay">
                <v-row no-gutters>
                    <v-col cols="12" sm="8" md="5" lg="4" xl="4">
                        <v-card class="login-card">
                            <!-- TÍTOL CAPÇALERA -->
                            <div class="login-header white--text pa-4">
                                <span class="titol">
                                    Bienvenid@ a tu web de Traycco
                                </span>
                            </div>

                            <!-- FORMULARI -->
                            <v-card-text class="pa-6">
                                <!-- Login normal client -->
                                <v-form v-if="loginMode === 'none'" @submit.prevent="login">
                                    <v-text-field
                                        v-model="username"
                                        label="Usuario"
                                        outlined
                                        dense
                                        class="mb-4"
                                        required
                                    />

                                    <v-text-field
                                        v-model="password"
                                        label="Contraseña"
                                        outlined
                                        dense
                                        type="password"
                                        class="mb-4"
                                        required
                                    />

                                    <v-btn
                                        color="green lighten-2"
                                        dark
                                        small
                                        type="submit"
                                        class="mb-6"
                                        :loading="isLoadingLogin"
                                        :disabled="isLoadingLogin"
                                    >
                                        Entrar
                                    </v-btn>
                                </v-form>

                                <!-- Login admin: selector de clients -->
                                <v-form v-if="loginMode === 'admin'" @submit.prevent="redirectClient">
                                    <v-autocomplete
                                        v-model="clientSeleccionat"
                                        :items="clients"
                                        item-title="nom_comercial"
                                        item-value="odoo_id"
                                        label="Selecciona un cliente"
                                        outlined
                                        dense
                                        class="mb-4"
                                        return-object
                                        clearable
                                    />

                                    <v-btn
                                        color="green lighten-2"
                                        dark
                                        small
                                        type="submit"
                                        class="mb-6"
                                        :loading="isLoadingLogin"
                                        :disabled="isLoadingLogin || !clientSeleccionat"
                                    >
                                        Entrar
                                    </v-btn>
                                </v-form>
                            </v-card-text>

                            <v-card-actions>
                                <div class="d-flex justify-space-between align-center" style="width: 100%">
                                    <v-img
                                        :src="logoBlancUrl"
                                        alt="Logo blanc"
                                        max-height="30"
                                        width="100"
                                    />

                                    <v-img
                                        :src="logoNegreUrl"
                                        alt="Logo negre"
                                        max-height="30"
                                        width="80"
                                    />
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>

        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            timeout="3000"
            multi-line
        >
            {{ snackbarMessage }}
        </v-snackbar>
    </v-app>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { useSnackbar } from '@/composables/useSnackbar'

export default {
    name: 'LoginClient',

    setup() {
        const router = useRouter()

        const logoBlancUrl = '/images/logo_blanc.png'
        const logoNegreUrl = '/images/logo_negre.png'

        const username = ref('')
        const password = ref('')

        const loginMode = ref('none')

        const clients = ref([])
        const clientSeleccionat = ref(null)

        const isLoading = ref(true)
        const isLoadingLogin = ref(false)

        const {
            snackbar,
            snackbarMessage,
            snackbarColor,
            showSnackbar
        } = useSnackbar()

        const allowedRoles = [
            'admin',
            'quality',
            'warehouseBCN',
            'warehouseMAD',
            'production',
            'planning',
            'comercial',
            'backoffice',
            'gerencia'
        ]

        const getCampListPath = (session = {}) => {
            const shopId = Number(session?.IdBotiga || 0)

            return shopId > 0
                ? `/cliente/CampList/${shopId}`
                : '/cliente/CampList'
        }

        const clearBrowserCookies = () => {
            document.cookie.split(';').forEach(cookie => {
                const cookieName = cookie.split('=')[0].trim()

                if (!cookieName) return

                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`

                const parts = window.location.hostname.split('.')

                if (parts.length > 2) {
                    const rootDomain = `.${parts.slice(-2).join('.')}`
                    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${rootDomain}`
                }
            })
        }

        const clearClientSessionData = () => {
            console.log('Entrant a clearClientSessionData()')

            clearBrowserCookies()

            sessionStorage.clear()
            localStorage.clear()

            console.log('LocalStorage després de netejar:', localStorage.length)
            console.log('SessionStorage després de netejar:', sessionStorage.length)
        }

        const getClient = async () => {
            const token = localStorage.getItem('token')

            console.log('Token trobat al carregar LoginClient:', token)

            if (!token) {
                console.log('No hi ha token. Netegem sessió client.')
                clearClientSessionData()
                loginMode.value = 'none'
                return false
            }

            try {
                const { data } = await axios.get('/api/authuser', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })

                console.log('Usuari autenticat detectat:', data)

                if (allowedRoles.includes(data.role)) {
                    console.log('És usuari intern/admin. No netegem sessió.')
                    loginMode.value = 'admin'
                    return true
                }

                console.log('No és admin. Netegem sessió client.')
                clearClientSessionData()
                loginMode.value = 'none'
                return false
            } catch (e) {
                console.error('Token invàlid o error obtenint authuser:', e)

                clearClientSessionData()
                loginMode.value = 'none'
                return false
            }
        }

        const fetchClients = async () => {
            try {
                const { data } = await axios.get('/api/admin/clients', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                })

                clients.value = data.map(client => ({
                    ...client,
                    nom_comercial: client.nom_comercial || client.name
                }))
            } catch (e) {
                console.error('Error carregant clients:', e)
                showSnackbar('Error cargando los clientes', 'error')
            }
        }

        const login = async () => {
            if (!username.value || !password.value) {
                showSnackbar('Usuario y contraseña requeridos', 'error')
                return
            }

            isLoadingLogin.value = true

            try {
                const { data } = await axios.post('/api/client/login', {
                    username: username.value,
                    password: password.value
                })

                localStorage.setItem('token', data.token)
                localStorage.setItem('clientSession', JSON.stringify(data.session))

                router.push(getCampListPath(data.session))
            } catch (e) {
                showSnackbar(
                    e.response?.data?.message || 'Error de autenticación con Odoo',
                    'error'
                )
            } finally {
                isLoadingLogin.value = false
            }
        }

        const redirectClient = async () => {
            if (!clientSeleccionat.value) {
                showSnackbar('Debes seleccionar un cliente', 'error')
                return
            }

            isLoadingLogin.value = true

            try {
                const { data } = await axios.post(
                    '/api/client/loginAdmin',
                    {
                        clientSeleccionat: clientSeleccionat.value
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                )

                localStorage.setItem('clientSession', JSON.stringify(data.session))

                router.push(getCampListPath(data.session))
            } catch (e) {
                showSnackbar(
                    e.response?.data?.message || 'Error de autenticación con Odoo',
                    'error'
                )
            } finally {
                isLoadingLogin.value = false
            }
        }

        const entrar = () => {
            if (!clientSeleccionat.value) {
                showSnackbar('Debes seleccionar un cliente', 'error')
                return
            }

            localStorage.setItem('clientSeleccionat', JSON.stringify(clientSeleccionat.value))
        }

        onMounted(async () => {
            const isAdmin = await getClient()

            if (isAdmin) {
                await fetchClients()
            }

            isLoading.value = false
        })

        return {
            username,
            password,
            clients,
            clientSeleccionat,
            entrar,
            login,
            redirectClient,
            loginMode,
            isLoading,
            isLoadingLogin,
            snackbar,
            snackbarMessage,
            snackbarColor,
            logoBlancUrl,
            logoNegreUrl,
            showSnackbar
        }
    }
}
</script>

<style scoped>
.video-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow: hidden;
}

.video-element {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: translate(-50%, -50%);
    z-index: -1;
}

.content-overlay {
    position: relative;
    z-index: 1;
    height: 100%;
}

.login-card {
    margin-top: 50px;
    margin-left: 50px;
    width: 500px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.login-header {
    background-color: rgba(33, 33, 33, 0.7);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: white;
    font-size: 18px;
    font-weight: bold;
}
</style>